/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

import { DialogManager } from '@ccxi/ccxi-shared-components/src/DialogQueue';

class CCAppsDialogManager {
    init(dialogManager, dialogView) {
        this.dialogManager = dialogManager || new DialogManager();
        this.dialogView = dialogView;
    }

    show = (content, config) => this.dialogManager
                                && this.dialogManager.show(content, config, this.dialogView);

    hide = (...params) => this.dialogManager && this.dialogManager.hide(...params);
}

export default new CCAppsDialogManager();
